"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _Poll = _interopRequireDefault(require("../Post/Poll"));

var _Attachments = _interopRequireDefault(require("../V2/Shared/Attachments"));

var _Reports = _interopRequireDefault(require("../V2/Reports"));

var TopicBodyContent = function TopicBodyContent(_ref) {
  var topicId = _ref.topicId,
      topicContent = _ref.topicContent,
      translatedTopicContent = _ref.translatedTopicContent,
      isTranslationInProgress = _ref.isTranslationInProgress,
      showEditor = _ref.showEditor,
      editor = _ref.editor,
      attachments = _ref.attachments,
      attachmentCdn = _ref.attachmentCdn,
      userSignature = _ref.userSignature,
      poll = _ref.poll,
      pollVotes = _ref.pollVotes,
      answeredPoll = _ref.answeredPoll,
      pollSelectionLoading = _ref.pollSelectionLoading,
      displayExtendedActions = _ref.displayExtendedActions,
      contentType = _ref.contentType,
      onShowAlert = _ref.onShowAlert,
      onPollUpdate = _ref.onPollUpdate,
      handlePollAnswer = _ref.handlePollAnswer,
      _ref$reportedContent = _ref.reportedContent,
      reportedContent = _ref$reportedContent === void 0 ? [] : _ref$reportedContent;
  return (0, _preact.h)("div", {
    id: "topic".concat(topicId),
    className: "post qa-topic-post-box"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('threaded-topic-body-wrapper', {
      'translation-loading': isTranslationInProgress,
      'with-attachments': attachments && attachments.length > 0
    })
  }, showEditor ? editor : (0, _preact.h)("div", {
    className: "topic-view-content-wrapper"
  }, (0, _preact.h)(_Content.default, {
    content: translatedTopicContent !== null && translatedTopicContent !== void 0 ? translatedTopicContent : topicContent,
    renderImagesAsLazy: false
  }), poll && (0, _preact.h)(_Poll.default, {
    poll: poll,
    contentType: contentType,
    topicId: topicId,
    onPollUpdate: onPollUpdate,
    pollVotes: pollVotes,
    onShowAlert: onShowAlert,
    answeredPoll: answeredPoll,
    pollSelectionLoading: pollSelectionLoading,
    handlePollSelection: handlePollAnswer,
    displayExtendedActions: displayExtendedActions
  }), reportedContent.length > 0 && (0, _preact.h)(_Reports.default, {
    reportedContent: reportedContent
  })), userSignature, attachments && attachments.length > 0 && (0, _preact.h)(_Attachments.default, {
    attachments: attachments,
    attachmentCdn: attachmentCdn
  })));
};

var _default = TopicBodyContent;
exports.default = _default;